import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpService } from '../../../core/services/http.service';
import { PurchaseType } from './purchaseType';
@Component({
    selector: 'app-purchase-type',
    templateUrl: './purchaseType.component.html',
    styleUrls: ['./purchaseType.component.css']
})
export class PurchaseTypeComponent implements OnInit, ControlValueAccessor {

    @Input('select-all') selectAll = 'true';
    @Input() value = '';
    @Output('change') change: EventEmitter<any> = new EventEmitter<any>();
    @Output('load') load: EventEmitter<any> = new EventEmitter<any>();

    list: Array<any>;
    constructor(private http: HttpService) { }

    ngOnInit() {
        this.getOrderTypeList();
    }

    handleChange(event) {
        event.stopPropagation();
        let purchaseObj: PurchaseType;
        this.list.map(el => {
            if (el['purchaseType'] === this.value) {
                purchaseObj = el;
            }
        });
        this.change.emit(purchaseObj);
        this.propagateChange(purchaseObj);
    }

    writeValue(value: any): void {

    }

    propagateChange = (_: any) => { };
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {

    }

    getOrderTypeList() {
        this.http.get('api/srm/purchase/purchaseType', {}).toPromise().then(res => {
            if (res['head']['status'] === 1) {
                this.list = res['body']['listdata'] || [];
                // this.list.unshift({});
                this.load.emit(this.list);
            }
        });
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/purchaseType/purchaseType.component.ts